export const headerBundle = {
  title: { ko: "세대 상세 조회", en: "Unit Detail Search", es: "Consulta detallada por unidad" },
  search: { ko: "검색", en: "Search", es: "Buscar" },
  select: {
    dong: { ko: "동 선택", en: "Select Building", es: "Seleccionar edificio" },
    ho: { ko: "호 선택", en: "Select Unit", es: "Seleccionar unidad" }
  },
  alert: {
    dongFirst: {
      ko: "동을 선택해주세요.",
      en: "Please select a building.",
      es: "Seleccione un edificio."
    },
    hoFirst: {
      ko: "호를 선택해주세요.",
      en: "Please select a unit.",
      es: "Seleccione una unidad."
    }
  },
  badge: {
    leak: { ko: "누수", en: "Leak", es: "Fuga" },
    overuse: { ko: "과다", en: "Overuse", es: "Exceso" }
  },
  floor: {
    suffix: { ko: "층", en: "F", es: "P" }
  },

  dong: { ko: "{dong} 동", en: "Building {dong}", es: "Edificio {dong}" },
  ho: { ko: "{ho}호", en: "Unit {ho}", es: "Unidad {ho}" },
  searchHint: {
    ko: "동·호수를 검색해보세요",
    en: "Search for a building and unit",
    es: "Busca un edificio y una unidad"
  }
}
